import { Link } from "react-router-dom";
import { useMemo } from "react";
import { trendingTags } from "../../../mocks/categories";
import { allQuizzes } from "../../../utils/allQuizzes";

const testimonials = [
  {
    id: 1,
    text: "OMG this quiz was SO accurate!! I got Moana and literally every single thing described me perfectly. Sent it to my whole class hahaha 💀",
    name: "Lily M.",
    grade: "8th grade student",
    avatar: "https://public.readdy.ai/ai/img_res/31b053acaaa730ca5149e8091cf49ef2.jpg",
  },
  {
    id: 2,
    text: "I took the Toca Boca house quiz 3 times with different friends and we all got different results lmaoo. The library manor one is literally me though no cap",
    name: "Zara K.",
    grade: "7th grade student",
    avatar: "https://readdy.ai/api/search-image?query=cute%20teenage%20girl%20portrait%20kawaii%20art%20style%20warm%20pink%20tones%20bright%20illustration%20cartoon%20avatar%20happy%20cheerful&width=150&height=150&seq=av002&orientation=squarish",
  },
  {
    id: 3,
    text: "The anime personality quiz got me as The Genius Strategist and I literally screenshotted and put it in my bio fr fr. This is the most accurate thing on the internet",
    name: "Jess T.",
    grade: "9th grade student",
    avatar: "https://readdy.ai/api/search-image?query=cute%20teenager%20portrait%20kawaii%20art%20style%20warm%20teal%20tones%20bright%20illustration%20cartoon%20avatar%20happy%20excited&width=150&height=150&seq=av003&orientation=squarish",
  },
];

function formatPlays(n: number): string {
  if (n >= 1000000) return `${(n / 1000000).toFixed(1)}M`;
  if (n >= 1000) return `${(n / 1000).toFixed(0)}K`;
  return String(n);
}

const RANK_COLORS = [
  "bg-[#FF6B6B] text-white",
  "bg-orange-400 text-white",
  "bg-amber-400 text-white",
  "bg-gray-200 text-gray-600",
  "bg-gray-100 text-gray-500",
];

export default function TrendingSection() {
  const top5 = useMemo(
    () => [...allQuizzes].sort((a, b) => b.totalPlays - a.totalPlays).slice(0, 5),
    []
  );

  const hotterQuiz = top5[0];

  return (
    <>
      {/* Trending Tags */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-8">
            <h2
              className="text-3xl font-extrabold text-gray-900"
              style={{ fontFamily: "'Nunito', sans-serif" }}
            >
              Hot Right Now 🌶️
            </h2>
            <p className="text-gray-400 text-sm mt-1">
              The biggest IP quizzes kids are obsessing over
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-3">
            {trendingTags.map((tag) => (
              <Link
                key={tag.id}
                to={`/categories?tag=${tag.slug}`}
                className="group flex items-center gap-2 px-5 py-2.5 rounded-full border-2 border-gray-200 hover:border-[#FF6B6B] hover:bg-orange-50 transition-all cursor-pointer whitespace-nowrap"
              >
                <span className="text-sm font-semibold text-gray-700 group-hover:text-[#FF6B6B]">
                  {tag.label}
                </span>
                <span className="text-xs text-gray-400 group-hover:text-[#FF6B6B]/60">
                  {tag.count} quizzes
                </span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* 🔥 Live Trending Leaderboard */}
      <section className="py-16 bg-[#FFF8F5]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-8 gap-3">
            <div>
              <span className="inline-block bg-[#FF6B6B]/10 text-[#FF6B6B] text-xs font-bold uppercase tracking-widest px-3 py-1 rounded-full mb-2">
                Live Rankings
              </span>
              <h2
                className="text-3xl font-extrabold text-gray-900"
                style={{ fontFamily: "'Nunito', sans-serif" }}
              >
                This Week&apos;s Most Played
              </h2>
            </div>
            <Link
              to="/categories"
              className="text-sm font-bold text-[#FF6B6B] flex items-center gap-1 hover:gap-2 transition-all cursor-pointer whitespace-nowrap"
            >
              See full ranking <i className="ri-arrow-right-line" />
            </Link>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {/* Left — Top 1 hero card */}
            <Link
              to={`/quiz/${top5[0].id}`}
              className="group relative rounded-2xl overflow-hidden cursor-pointer"
            >
              <div className="w-full h-72">
                <img
                  src={top5[0].image}
                  alt={top5[0].title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
              <div className="absolute top-4 left-4 bg-[#FF6B6B] text-white text-xs font-extrabold px-3 py-1 rounded-full">
                🔥 #1 This Week
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <span className="text-xs font-bold text-white/70 uppercase tracking-wider">
                  {top5[0].categoryLabel}
                </span>
                <h3
                  className="text-white font-extrabold text-lg leading-snug mt-1 mb-2"
                  style={{ fontFamily: "'Nunito', sans-serif" }}
                >
                  {top5[0].title}
                </h3>
                <div className="flex items-center gap-3">
                  <div className="flex items-center gap-1 text-xs text-white/80">
                    <i className="ri-user-line" />
                    <span>{formatPlays(top5[0].totalPlays)} plays</span>
                  </div>
                  <div className="flex items-center gap-1 text-xs text-amber-400">
                    <i className="ri-star-fill" />
                    <span>{top5[0].rating}</span>
                  </div>
                </div>
              </div>
            </Link>

            {/* Right — Ranks #2 to #5 compact list */}
            <div className="flex flex-col gap-3">
              {top5.slice(1).map((quiz, i) => (
                <Link
                  key={quiz.id}
                  to={`/quiz/${quiz.id}`}
                  className="group flex items-center gap-4 bg-white rounded-xl px-4 py-3 hover:border-[#FF6B6B]/30 border border-gray-100 hover:-translate-y-0.5 transition-all cursor-pointer"
                >
                  {/* Rank badge */}
                  <div className={`w-8 h-8 flex items-center justify-center rounded-full text-xs font-extrabold flex-shrink-0 ${RANK_COLORS[i + 1]}`}>
                    {i + 2}
                  </div>
                  {/* Thumbnail */}
                  <div className="w-14 h-14 rounded-lg overflow-hidden flex-shrink-0">
                    <img
                      src={quiz.image}
                      alt={quiz.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-200"
                    />
                  </div>
                  {/* Info */}
                  <div className="flex-1 min-w-0">
                    <span className="text-xs font-bold text-[#FF6B6B] uppercase tracking-wider">
                      {quiz.categoryLabel}
                    </span>
                    <h4
                      className="text-gray-900 font-extrabold text-sm leading-snug truncate group-hover:text-[#FF6B6B] transition-colors"
                      style={{ fontFamily: "'Nunito', sans-serif" }}
                    >
                      {quiz.title}
                    </h4>
                  </div>
                  {/* Plays + rating */}
                  <div className="flex flex-col items-end gap-1 flex-shrink-0">
                    <span className="text-xs text-gray-400 whitespace-nowrap">
                      {formatPlays(quiz.totalPlays)} plays
                    </span>
                    <div className="flex items-center gap-0.5 text-xs text-amber-400">
                      <i className="ri-star-fill" />
                      <span className="text-gray-500">{quiz.rating}</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2
              className="text-4xl font-extrabold text-gray-900"
              style={{ fontFamily: "'Nunito', sans-serif" }}
            >
              How It Works
            </h2>
            <p className="text-gray-500 text-sm mt-2">3 steps to discover the real you</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              {
                step: "01",
                icon: "ri-search-eye-line",
                title: "Pick Your Quiz",
                desc: "Browse 500+ viral quizzes across games, anime, Disney, personality tests, and more!",
                color: "bg-[#FF6B6B]",
              },
              {
                step: "02",
                icon: "ri-image-2-line",
                title: "Choose Your Images",
                desc: "Answer fun questions by picking pictures. No boring text, just vibes. Takes 2-3 minutes!",
                color: "bg-[#2DD4BF]",
              },
              {
                step: "03",
                icon: "ri-share-forward-2-line",
                title: "Share Your Result",
                desc: "Get your personalized result card and share it with your friends on TikTok or Pinterest!",
                color: "bg-[#FBBF24]",
              },
            ].map((item) => (
              <div
                key={item.step}
                className="relative bg-[#FFF8F5] rounded-2xl p-8 text-center"
              >
                <div
                  className="absolute -top-4 left-8 text-5xl font-extrabold text-gray-100"
                  style={{ fontFamily: "'Nunito', sans-serif" }}
                >
                  {item.step}
                </div>
                <div className={`w-14 h-14 flex items-center justify-center rounded-2xl ${item.color} text-white text-2xl mx-auto mb-4`}>
                  <i className={item.icon} />
                </div>
                <h3
                  className="font-extrabold text-gray-900 text-lg mb-2"
                  style={{ fontFamily: "'Nunito', sans-serif" }}
                >
                  {item.title}
                </h3>
                <p className="text-gray-500 text-sm leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-20 bg-[#1A1A1A] overflow-hidden">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2
              className="text-4xl font-extrabold text-white"
              style={{ fontFamily: "'Nunito', sans-serif" }}
            >
              What Quiz Lovers Say 💬
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {testimonials.map((t) => (
              <div key={t.id} className="bg-white/5 border border-white/10 rounded-2xl p-6">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                    <img src={t.avatar} alt={t.name} className="w-full h-full object-cover object-top" />
                  </div>
                  <div>
                    <p className="text-white font-bold text-sm">{t.name}</p>
                    <p className="text-gray-400 text-xs">{t.grade}</p>
                  </div>
                  <div className="ml-auto flex gap-0.5">
                    {[1, 2, 3, 4, 5].map((s) => (
                      <i key={s} className="ri-star-fill text-amber-400 text-xs" />
                    ))}
                  </div>
                </div>
                <p className="text-gray-300 text-sm leading-relaxed">&quot;{t.text}&quot;</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Banner */}
      <section className="py-24 bg-gradient-to-r from-[#FF6B6B] to-[#FF8E53]">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <h2
            className="text-4xl md:text-6xl font-extrabold text-white mb-4"
            style={{ fontFamily: "'Nunito', sans-serif" }}
          >
            Ready to Discover
            <br />
            the Real You?
          </h2>
          <p className="text-white/80 text-lg mb-8 max-w-md mx-auto">
            Join millions of quiz lovers. It&apos;s free, fun, and totally shareable!
          </p>
          <Link
            to={`/quiz/${hotterQuiz.id}`}
            className="inline-flex items-center gap-2 px-10 py-4 bg-white text-[#FF6B6B] font-extrabold text-base rounded-full hover:scale-105 transition-transform cursor-pointer whitespace-nowrap"
          >
            Take My First Quiz
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </section>
    </>
  );
}
